// src/components/Shared/ProfilesTab.jsx
import React, { useEffect } from 'react';
import { Box, Typography, Alert, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ProfileRow from './ProfileRow';

const ProfilesTab = ({
  profiles = [],
  loading,
  error,
  selectedProfileId,
  onSelectProfile,
  emptyMessage,
  hintMessage
}) => {
  const { t } = useTranslation();
  const hasProfiles = profiles && profiles.length > 0;

  useEffect(() => {
    if (!loading && !error && hasProfiles && !selectedProfileId) {
      onSelectProfile(profiles[0].id);
    }
  }, [loading, error, hasProfiles, selectedProfileId, onSelectProfile, profiles]);

  if (loading) return <Typography sx={{ p: 2 }} variant="body2" color="text.secondary">{t('common.loading', 'Načítavam...')}</Typography>;
  
  if (error) return <Alert severity="error" sx={{ m: 1 }}>{error}</Alert>;

  if (!hasProfiles) {
    return (
      <Alert severity="info" sx={{ mt: 1, borderRadius: 2 }}>
        {emptyMessage || t('profiles.noProfiles', 'Zatiaľ nemáš vytvorený žiadny profil.')}
      </Alert>
    );
  }

  return (
    <Box sx={{ mt: 1 }}>
      {hintMessage && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block', px: 0.5 }}>
          {hintMessage}
        </Typography>
      )}
      
      <Stack spacing={0}>
        {profiles.map((p) => (
          <ProfileRow
            key={p.id}
            profile={p}
            selected={String(selectedProfileId) === String(p.id)}
            onSelect={() => onSelectProfile(p.id)}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default ProfilesTab;